import React from 'react';
import { MatrixBackground } from './components/MatrixBackground';
import { LandingPage } from './pages/LandingPage';
import { RecentPurchasePopup } from './components/RecentPurchasePopup';
export function App() {
  return <div className="relative min-h-screen w-full overflow-x-hidden text-white" style={{
    backgroundImage: "url('https://res.cloudinary.com/dab9nhevk/image/upload/v1772492976/corridor-bg_b9prsc.jpg')",
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed',
    backgroundColor: '#000308'
  }} data-id="element-0">
      <MatrixBackground data-id="element-1" />
      <main className="relative z-10" data-id="element-2">
        <LandingPage lang="en" data-id="element-3" />
      </main>
            {/* Popup compra reciente — fuera del main */}
      <RecentPurchasePopup data-id="element-4" />
    </div>;
}